import React, { Component } from 'react';
import edit_icon from '../../../../Images/Daikin_Images/image/Edit.png';
import Top_Bar from '../../../Part_Sample/Top_Bar';

import FcuOperation from './FcuOperation';
import DehumiOperation from './DehumiOperation';
import StatusOperation from './StatusOperation';
import SwitchOperation from './SwitchOperation';
import LevelOperation from './LevelOperation';
import LevelSwOperation from './LevelSwOperation';
import ShutterOperation from './ShutterOperation';
import DoorLockOperation from './DoorLockOperation';
import RGBWOperation from './RGBWOperation';
import HrvOperation from './HrvOperation';

export default class Operation_Screen extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
	}

	handlePrevious = () => {
		let from = this.props.param.from;
		if (from == 'Group_Details') {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
			from = this.props.param.group_detail_from;
			// Retain scroll position of groups screen
			this.props.content_handler(this.props.param.from, { from: from, group_info: this.props.param.group_info, group_id: this.props.param.group_id, mp_scroll_top: this.props.param.mp_scroll_top });
		} else if (from == 'Dashboard') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			this.props.content_handler(this.props.param.from, { groups: this.props.param.groups, scenes: this.props.param.scenes });
		} else if (this.props.param.from == 'Layout') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			window.app.receiver.stored_params.layout_id = this.props.param.layout_id;
			window.app.receiver.next_component = 'Layout';
			window.app.receiver.getGroups();
		}
	}

	handleEdit = () => {
		this.props.content_handler('Edit_Point_Settings', { point_id: this.props.param.point_id, from: 'Operation_Screen', original_from: this.props.param.from, group_info: this.props.param.group_info, groups: this.props.param.groups });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let operation_component = null;
		switch (this.props.param.point_info.type) {
			case 'Ac':
			case 'Ahu':
				operation_component =
					<FcuOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			case 'Dehumi':
				operation_component =
					<DehumiOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			case 'Status':
				operation_component =
					<StatusOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			case 'Switch':
				operation_component =
					<SwitchOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			case 'Level':
				operation_component =
					<LevelOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
					/>
				break;
			case 'LevelSw':
				operation_component =
					<LevelSwOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			case 'Shutter':
				operation_component =
					<ShutterOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
					/>
				break;
			case 'Lock':
				operation_component =
					<DoorLockOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
					/>
				break;
			case 'Rgbw':
				operation_component =
					<RGBWOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
					/>
				break;
			case 'Hrv':
				operation_component =
					<HrvOperation
						point_id={this.props.param.point_id}
						point_info={this.props.param.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						colours={this.props.colours}
					/>
				break;
			default:
				operation_component = <div></div>;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.point_info.name}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					{operation_component}
				</div>
			</div>
		)
	}
}